const FJMediaImportModelType = {
    folder: 'folder',
    file: 'file',
};

const FJMediaImportListStatus = {
    init: 'init',
    loading: 'loading',
    success: 'success',
    failed: 'failed',
    noSessionId: 'noSessionId',
};

export {  FJMediaImportModelType, FJMediaImportListStatus };
